import { _decorator, Button, Label, Node } from 'cc';
import Lobby from '../../../../../System/Lobby';
import HistoryDetailData from '../../../../Data/DataObject/History/HistoryDetailData';
import BaseHistoryRecord from './BaseHistoryRecord';
import BaseHistoryDetailRecord from '../HistoryDetailRecord/BaseHistoryDetailRecord';
import MultiThemeSource from '../../../../../../common/scripts/Toolkit/Components/MultiTheme/MultiThemeSource';
import { copyToClipboard } from '../../../../../../common/scripts/Toolkit/Utils/Utility';
import SlotGameText from '../../../../Data/Config/SlotGameTextSet';
import LobbyHistoryData from '../../../../Data/DataObject/History/LobbyHistoryData';
import { FeatureActivityEventName } from '../../../../Data/Config/FeatureActivityConfig';

const { ccclass, property, requireComponent } = _decorator;
const EVENT_DISABLE = 'EVENT_DISABLE';

enum EventType {
    CLOSE = 'CLOSE',
    OPEN_HISTORY_DETAIL = 'OPEN_HISTORY_DETAIL',
}

@ccclass('BasicHistoryRecord')
@requireComponent(MultiThemeSource)
export default class BasicHistoryRecord extends BaseHistoryRecord {
    public static readonly EVENT_TYPE = EventType;

    @property(Label)
    private readonly transactionIDLabel: Label = null;

    @property(Button)
    private readonly expandButton: Button = null;

    @property(Button)
    private readonly copyButton: Button = null;

    @property(BaseHistoryDetailRecord)
    private readonly historyDetailRecord: BaseHistoryDetailRecord = null;

    protected declare historyData: LobbyHistoryData;
    private _expandThemeSource: MultiThemeSource = null;
    private _detailData: HistoryDetailData = null;
    private _getDetail: () => Promise<HistoryDetailData> = null;
    private _isExpand: boolean = false;

    public get isExpand() {
        return this._isExpand;
    }
    public set isExpand(value: boolean) {
        if (this._isExpand === value) {
            return;
        }
        this._isExpand = value;
        this.expandThemeSource.theme = value ? 1 : 0;
    }

    private get expandThemeSource() {
        if (!this._expandThemeSource) {
            this._expandThemeSource = this.getComponent(MultiThemeSource);
        }
        return this._expandThemeSource;
    }

    public onLoad() {
        this.expandButton.on(Button.EventType.CLICK, async () => {
            if (!this.isExpand) {
                // if (!this._detailData) {
                //     this._detailData = await Promise.race([this._getDetail(), Delay.event(EVENT_DISABLE, this.node).then(() => null)]);
                // }
                // if data is null, it means the node has been disabled
                // if (!this._detailData) {
                //     return;
                // }
                this.historyDetailRecord.display(this.historyData);
                Lobby.activity.send(FeatureActivityEventName.OpenHistoryDetail, {
                    TransactionID: this.historyData.transactionID,
                });
            }
            this.isExpand = !this.isExpand;
        });
        this.copyButton.on(Button.EventType.CLICK, this._copyTransactionID, this);
        this.transactionIDLabel.on(Node.EventType.TOUCH_END, this._copyTransactionID, this);
    }

    public onDisable() {
        this.node.emit(EVENT_DISABLE);
    }

    public display(data: LobbyHistoryData, getDetail: () => Promise<HistoryDetailData>) {
        if (this.historyData === data) {
            return;
        }
        this.historyData = data;
        this._detailData = null;
        this._getDetail = getDetail;
        this.updateContent();
    }

    protected updateContent() {
        super.updateContent();
        this.transactionIDLabel.string = this.historyData.transactionID;
    }

    private _copyTransactionID() {
        copyToClipboard(this.historyData.transactionID).then((isSuccess) => {
            if (isSuccess) {
                Lobby.notification.show(SlotGameText.TEXT_COPIED, 1000);
            }
        });
    }
}
